import _ from 'underscore';

import {BenchlingAction} from 'redux-stores/Action';

import {LoadingStateActionTypes} from './LoadingStateReduxActions';

export enum LoadingState {
  LOADING = 'LOADING',
  LOADED = 'LOADED',
  FAILED = 'FAILED',
}

export interface ModelLoadingState {
  [modelType: string]: {
    [modelKey: string]: LoadingState;
  };
}

export const MODEL_LOADING_INITIAL_STATE: ModelLoadingState = {};

export function getLoadingState(
  state: ModelLoadingState = {},
  modelType: string,
  modelKey: string
): LoadingState | null {
  if (!state[modelType]) {
    return null;
  }
  return state[modelType][modelKey] || null;
}

function updateState(
  state: ModelLoadingState,
  modelType: string,
  modelKeys: Array<string>,
  newLoadingState: LoadingState
): ModelLoadingState {
  return {
    ...state,
    [modelType]: {
      ...state[modelType],
      ..._.object(modelKeys.map((key) => [key, newLoadingState])),
    },
  };
}

function removeFromLoadingState(
  state: ModelLoadingState,
  modelType: string,
  modelKeys: Array<string>
): ModelLoadingState {
  return {
    ...state,
    // eslint-disable-next-line no-restricted-syntax
    [modelType]: _.omit(state[modelType], modelKeys),
  };
}

export default function reduceLoadingState(
  state: ModelLoadingState = MODEL_LOADING_INITIAL_STATE,
  action: BenchlingAction
): ModelLoadingState {
  switch (action.type) {
    case LoadingStateActionTypes.MODEL_LOADING_STARTED:
      return updateState(state, action.modelType, action.modelKeys, LoadingState.LOADING);
    case LoadingStateActionTypes.MODEL_LOADING_COMPLETED:
      return updateState(state, action.modelType, action.modelKeys, LoadingState.LOADED);
    case LoadingStateActionTypes.MODEL_LOADING_FAILED:
      return updateState(state, action.modelType, action.modelKeys, LoadingState.FAILED);
    case LoadingStateActionTypes.MODEL_LOADING_INVALIDATED:
      return removeFromLoadingState(state, action.modelType, action.modelKeys);
    default:
      return state;
  }
}
